import { Box, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IFileAttachmentTypography {
  isAttached: boolean;
}

export const FileAttachmentTypography = ({
  isAttached,
}: IFileAttachmentTypography) => {
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];

  return (
    <Box mb={3}>
      <Typography variant={'body1'} mb={1} component='h3'>
        {dictionary.uploadFile.addFiles}
      </Typography>
      <Typography variant={'body3'} mb={2}>
        {isAttached
          ? dictionary.uploadFile.addFilesSubtitleOpen
          : dictionary.uploadFile.addFilesSubtitle}
      </Typography>
    </Box>
  );
};
